import { render, staticRenderFns } from "./FilmPosters.vue?vue&type=template&id=c0d288a0&"
import script from "./FilmPosters.vue?vue&type=script&lang=js&"
export * from "./FilmPosters.vue?vue&type=script&lang=js&"
import style0 from "./FilmPosters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports